import { cn } from "@kyan/ui";

export interface DividerProps {
  className?: string;
  isHorizontal?: boolean;
}

export const Divider: React.FC<DividerProps> = ({
  className,
  isHorizontal = true,
}) => (
  <div
    className={cn(
      "bg-divider",
      {
        "h-px w-full": isHorizontal,
        "h-full w-px": !isHorizontal,
      },
      className,
    )}
  />
);
